<template>
    <div class="table-list lease-done">
        <check-in :contractObj="contractObj" :type="checkInType" loginType="COMPANY"></check-in>
        <contract-release :cid="contractId" :obj="filterByWord[selected]"></contract-release>
        <new-bill :cid="contractId" @saveBillStatus="getLeaseProcessList"></new-bill>
        <auto-create :key="'create'+componentKey" :cid="contractId" :isAutoCreate="isAutoCreate" @saveAutoCreate="setAutoCreate" @saveAutoStatus="getLeaseProcessList"></auto-create>
        <auto-send :key="'send'+componentKey" :cid="contractId" :isAutoSend="isAutoSend" @saveAutoSend="setAutoSend" @saveAutoStatus="getLeaseProcessList"></auto-send>
        <upload-meter-record></upload-meter-record>
        <release-appeal :contractObj="contractObj"></release-appeal>
        <modal class="throw-lease" :display="modalState.throwLease" @modalStatus="closeModal('throwLease')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>退租點交</h1>
            <div class="content">
                確定要退租點交“{{throwLease.name}}”的合約嗎？確定後將通知房客退租點交
            </div>
            <div class="btn-group">
                <button class="default-button" @click="setThrowLease(), $analyticsBiz.logEvent('退租點交', { screen_name: '退租點交'})">確認</button>
                <button class="border-button" @click="closeModal('throwLease')">取消</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="contract-date">租約起訖日</span>
            <span class="address">地址</span>
            <span class="lease-type">租約類型</span>
            <span class="lease-status">租約狀態</span>
            <span class="pay-status">繳款狀態</span>
            <span class="record">
                <select-record v-model="recordType"></select-record>
            </span>
            <span class="tenant">租客</span>
            <span class="agent">業務</span>
            <span class="rent">租金</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="filterByWord.length == 0 && leaseProcessList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-else-if="leaseProcessList.length == 0" class="is-empty">0 筆資料</div>
            <ul  v-else>
                <li v-for="(house,index) in filterByWord" :key="index">
                    <span class="contract-date">{{getFormatDateTime(house.contractBeginTime)}} - {{getFormatDateTime(house.contractEndTime)}}</span>
                    <span class="address">
                        {{house.address}}
                        <!-- {{house.address.length >= 17?compressWord(house.address, 17):house.address}}
                        <div v-if="house.address.length >= 17" class="full-word">
                            <span>
                                {{house.address}}
                            </span>
                        </div> -->
                    </span>
                    <span class="lease-type" v-if="house.isPaperContract">紙本合約</span>
                    <span class="lease-type" v-else>一般合約</span>
                    <span class="lease-status">
                        <span v-if="house.contractStatus == 9 && !house.isLandlordReleasedContract">進行中</span>
                        <span v-if="house.isLandlordReleasedContract">退租中</span>
                        <div class="info" v-if="house.isLandlordReleasedContract && house.contractReleaseAppealStatus === 'HAD_APPEAL'">
                            <word-tips-hover data="退租申訴中" width="104px" left="20px" top="-15px"></word-tips-hover>
                        </div>
                    </span>
                    <span class="pay-status">
                        <span class="red" v-if="house.tenantReleaseTime">房客申請退租</span>
                        <span class="red" v-else-if="house.billStatus == 'OVERDUE'">{{house.statusDesc.overdueCount}} 筆欠款</span>
                        <span class="blue" v-else-if="house.billStatus == 'UNPAID'">{{house.statusDesc.uncreatedBillBeginDate}}~{{house.statusDesc.uncreatedBillEndDate}}尚未收租</span>
                        <span class="gray" v-else-if="house.billStatus == 'COMPLETELY_PAID'">正常</span>
                    </span>
                    <span v-if="recordType === 'WATER'" class="record">{{house.thisMonthWaterUtilityMeter?toCurrency(house.thisMonthWaterUtilityMeter):'-'}}</span>
                    <span v-if="recordType === 'ELECTRICT'" class="record">{{house.thisMonthElectricityUtilityMeter?toCurrency(house.thisMonthElectricityUtilityMeter):'-'}}</span>
                    <span v-if="recordType === 'GAS'" class="record">{{house.thisMonthGasUtilityMeter?toCurrency(house.thisMonthGasUtilityMeter):'-'}}</span>
                    <span class="tenant">{{house.tenantName}}</span>
                    <span class="agent">{{house.agentName}}</span>
                    <span class="rent">{{toCurrency(house.rentPrice)}}</span>
                    <!-- <span class="leave-date">{{house.contractDueDate}} 天</span> -->
                    <span class="action">
                        <dot-dropmenu>
                            <ul >
                                <li v-if="house.isPaperContract" @click="getContractPDF(house.contractCid), $analyticsBiz.logEvent('查看紙本合約', { screen_name: '查看紙本合約'})">紙本合約</li>
                                <li v-else @click="getContract(house.contractCid), $analyticsBiz.logEvent('查看合約', { screen_name: '查看合約'})">查看合約</li>
                                <li @click="setNewBill(house), $analyticsBiz.logEvent('新增費用', { screen_name: '新增費用'})"
                                    v-if="bizAuth.createContractBill.hasRight">新增帳單</li>
                                <li @click="toBillDetail(house.address), $analyticsBiz.logEvent('帳單紀錄', { screen_name: '帳單紀錄'})"
                                    v-if="bizAuth.viewBillRecord.hasRight">帳單紀錄</li>
                                <li @click="$analyticsBiz.logEvent('入住點交', { screen_name: '入住點交'}), houseCheckIn(house, 'CHECK_IN')"
                                    v-if="house.checkInStatus==='NORMAL'">入住點交</li>
                                <li @click="$analyticsBiz.logEvent('入住點交明細', { screen_name: '入住點交明細'}), houseCheckIn(house, 'DETAIL')"
                                    v-else>入住點交明細</li>
                                <li @click="$analyticsBiz.logEvent('房客拍表紀錄', { screen_name: '房客拍表紀錄'}), toMeterRecord(house.contractSeq)"
                                    >拍表紀錄</li>
                                <li @click="contractId = house.contractCid, isAutoCreate = house.isAutoCreated, setAutoCreate(), $analyticsBiz.logEvent('自動收租', { screen_name: '自動收租'})" 
                                    v-if="bizAuth.autoCollectRentSetting.hasRight">自動收租</li>
                                <li @click="contractId = house.contractCid, isAutoSend = house.isAutoSend, setAutoSend(), $analyticsBiz.logEvent('收租提醒', { screen_name: '收租提醒'})"
                                    v-if="bizAuth.collectRentNotify.hasRight">收租提醒</li>
                                <li v-if="house.tenantReleaseTime && bizAuth.releaseContract.hasRight" 
                                    @click="contractId = house.contractCid, selected = index, releaseContract(), $analyticsBiz.logEvent('房客申請退租', { screen_name: '房客申請退租'})"
                                    >房客已申請退租</li>
                                <li v-if="house.contractStatus == 9 && !house.isLandlordReleasedContract && bizAuth.releaseContract.hasRight" 
                                @click="setThrowLease(house.contractCid, house.isPaperContract)">退租點交</li>
                                <li v-if="house.isLandlordReleasedContract" 
                                    @click="contractObj = house, selected = index, $store.dispatch('setModalStatus', {state: true, type: 'bizReleaseAppeal'}), $analyticsBiz.logEvent('退租申訴', { screen_name: '退租申訴'})"
                                    >退租申訴</li>
                                <li v-if="house.allowRenewal" @click="$router.push({name: 'bizRenewalContract', query: {contractCid: house.contractCid}}), $analyticsBiz.logEvent('續租', { screen_name: '續租'})">續租</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import newBill from '@/components/bussiness/widges/modals/newBill.vue';
import autoCreate from '@/components/bussiness/widges/modals/autoCreate.vue';
import autoSend from '@/components/bussiness/widges/modals/autoSend.vue';
import contractRelease from '@/components/bussiness/widges/modals/contractRelease.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import checkIn from '@/components/bussiness/widges/modals/checkIn.vue';
import uploadMeterRecord from '@/components/bussiness/mgtCategory/leaseMgt/leaseProcess/uploadMeterRecord.vue';
import releaseAppeal from '@/components/bussiness/mgtCategory/leaseMgt/leaseProcess/releaseAppeal.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';
import selectRecord from '@/components/bussiness/widges/input/selectRecord.vue';
import { mapGetters } from 'vuex'

import { 
    getContractPDF
    } from "@/apis/company/leaseMgt.js"; 
export default {
    data () {
        return{
            // leaseProcessList: [],
            recordType: 'WATER',
            filterEmpty: false,
            leaseDataEmpty: false,
            leaseDataError: false,
            isLoading: true,
            contractId: null,
            isAutoCreate: false,
            isAutoSend: false,
            componentKey: 0,
            selected: 0,
            modalState: {
                throwLease: false
            },
            throwLease: {
                contractCid: null,
                name: null,
            },
            checkInType: 'CHECK_IN',
            contractObj: null
        }
    },
    created () {
        this.getLeaseProcessList()
    },
    watch: {
        newBill: {
            handler: function (val) {
                if(val.rent){
                    if(this.checkIsNum(val.rent)){
                        this.error.newBill.rent = ''
                    }else{
                        this.error.newBill.rent = '請填寫數字'
                    }
                }
                if(val.gasBill) {
                    if(this.checkIsNum(val.gasBill)){
                        this.error.newBill.gasBill = ''
                    }else{
                        this.error.newBill.gasBill = '請填寫數字'
                    }
                }
                if(val.tvBill) {
                    if(this.checkIsNum(val.tvBill)){
                        this.error.newBill.tvBill = ''
                    }else{
                        this.error.newBill.tvBill = '請填寫數字'
                    }
                }
                if(val.waterBill) {
                    if(this.checkIsNum(val.waterBill)){
                        this.error.newBill.waterBill = ''
                    }else{
                        this.error.newBill.waterBill = '請填寫數字'
                    }
                }
                if(val.parkinBill) {
                    if(this.checkIsNum(val.parkingBill)){
                        this.error.newBill.parkingBill = ''
                    }else{
                        this.error.newBill.parkingBill = '請填寫數字'
                    }
                }
                if(val.electricityBill) {
                    if(this.checkIsNum(val.electricityBill)){
                        this.error.newBill.electricityBill = ''
                    }else{
                        this.error.newBill.electricityBill = '請填寫數字'
                    }
                }
                if(val.interneBill) {
                    if(this.checkIsNum(val.internetBill)){
                        this.error.newBill.internetBill = ''
                    }else{
                        this.error.newBill.internetBill = '請填寫數字'
                    }
                }
                if(val.cleaningBill) {
                    if(this.checkIsNum(val.cleaningBill)){
                        this.error.newBill.cleaningBill = ''
                    }else{
                        this.error.newBill.cleaningBill = '請填寫數字'
                    }
                }
                if(val.managementBill) {
                    if(this.checkIsNum(val.managementBill)){
                        this.error.newBill.managementBill = ''
                    }else{
                        this.error.newBill.managementBill = '請填寫數字'
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        setFilterDefault: function () {
            this.$store.dispatch('setBizLeaseProcessFilterDefault')
        },
        getLeaseProcessList: function () {
            this.$store.dispatch('getBizLeaseProcessMgtList')
            .then(()=>{
                this.isLoading = false
            })
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
        },
        houseCheckIn: function (contractObj, type) {
            this.checkInType = type
            this.contractObj = contractObj
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizCheckIn'})
        },
        closeModal: function (type) {
            this.$store.commit('modalStatus/set_modal_mode', false)
            if( type == 'newBill' ){
                this.modalState.newBill = false
                this.setNewBillDefault()
            }else if( type == 'throwLease' ){
                this.modalState.throwLease = false
            }
        },
        checkIsNum: function (num) {
            let numerical = /^[0-9]*$/
            return numerical.test(num)?true:false
        },
        toContractDetail: function (cid) {
            window.open('/landlord/leasemanagement/contractdetail?cid='+cid)
        },
        toBillDetail: function (data) {
            let routerUrl = this.$router.resolve({ name: 'billMgt', query: { 'filterWord': data }})
            window.open(routerUrl.href, '_blank');
        },
        toMeterRecord: function (seq) {
            this.$router.push({name: 'bizMeterRecord', query: {'contractSeq': seq}})
        },
        setThrowLease: function (cid, isPaper) {
            if(isPaper){
                this.$router.push({name: 'bizContractDefault', query: {'contractCid': cid, 'mode': 'contract', 'type': 'release','file': 'pdf'}})
            }else{
                this.$router.push({name: 'bizContractDefault', query: {'contractCid': cid, 'mode': 'contract', 'type': 'release'}})
            }
        },
        getContractPDF: function (cid) {
            let params = {
                contractCid: cid
            }
            getContractPDF(params)
            .then( res => {
                console.log(res)
                
                if(res.status == 200){
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    window.open(url);
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        setNewBill: function (item) {
            // console.log({contractId: item.contractCid, contractSeq: item.contractSeq})
            this.$router.push({name: 'bizNewBill', query: {contractId: item.contractCid, contractSeq: item.contractSeq}})
        },
        setAutoCreate: function () {
            this.componentKey += 1
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizAutoCreate'})
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        setAutoSend: function () {
            this.componentKey += 1
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizAutoSend'})
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        setBillStatus: function (value) {
            // console.log('billStatus:'+ value)
            this.getLeaseProcessList()
        },
        releaseContract: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizContractRelease'})
        },
        checkMeterUploaded: function (item, beginDate, list) {
            beginDate = new Date(beginDate-288000000)
            let beginMonth = new Date(beginDate.getFullYear(), beginDate.getMonth(), 1);
            let today = new Date();
            let endMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            let diffMonth = this.diffMonth(beginMonth, endMonth)
            let flag = true
            // console.log(item.address+item.tenantName)
            // console.log('beginDate',beginDate)
            // console.log('list',list)
            // console.log('diffMonth',this.diffMonth(beginMonth, endMonth))
            if(diffMonth>0){
                for (let i = 0; i < diffMonth; i++) {
                    const element = new Date(list[i]).getTime();
                    // const element = '2021-10-04 18:21:57';
                    let firstDate = beginMonth.setMonth(beginMonth.getMonth()+i)
                    let lastDay = beginMonth.setMonth(beginMonth.getMonth()+(i+1))
                    // console.log('firstDate',firstDate)
                    // console.log('lastDay',lastDay)
                    // console.log('element',element)
                    if(element){
                        if(firstDate<=element && lastDay>=element){
                        }else{
                            flag = false
                        }
                    }else{
                        flag = false
                    }
                    
                }
            }else{
                return true
            }
            return flag
            // this.diffMonth(beginMonth, endMonth)
        },
        diffMonth: function (minDate, maxDate){
            let minYear = minDate.getFullYear();
            let minMonth = minDate.getMonth()+1;
            let maxYear = maxDate.getFullYear();
            let maxMonth = maxDate.getMonth()+1;
            return (maxYear*12+maxMonth) - (minYear*12+minMonth)
        },
        checkUploadDate: function (item, beginDate, list) {
            let filterDateStart = Date.parse(this.filterQuery.date[0]).valueOf(),
                filterDateEnd = Date.parse(this.filterQuery.date[1]).valueOf(),
                result = false
            beginDate = new Date(new Date(beginDate).setHours(0, 0, 0, 0)).getTime()
            // console.log(item.address+item.tenantName)
            // console.log('beginDate',beginDate)
            // console.log('filterDateStart',filterDateStart)
            // console.log('filterDateEnd',filterDateEnd)
            // console.log('list',list)
            if(filterDateStart>=beginDate){
                for (let i = 0; i < list.length; i++) {
                    const element = new Date(list[i]).getTime();
                    if(element){
                        if(filterDateStart<=element && filterDateEnd>=element){
                            result = true
                        }
                    }else{
                        result = false
                    }
                }
            }else{
                result = true
            }
            
            return result
        }
    },
    computed: {
        fileterByCounty: function () {
            return this.leaseProcessList.filter((item) => {
                if(this.filterQuery.county){
                    if(item.county.includes(this.filterQuery.county) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        fileterByDistrict: function () {
            return this.fileterByCounty.filter((item) => {
                if( this.filterQuery.district){
                    if(item.district.includes(this.filterQuery.district) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByRent: function () {
            return this.fileterByDistrict.filter((item) => {
                if( this.filterQuery.rent ){
                    if( this.filterQuery.rent[1] >= 100000){
                        if( this.filterQuery.rent[0] <= item.rentPrice){
                            return item
                        }
                    }else{
                        if( this.filterQuery.rent[0] <= item.rentPrice && this.filterQuery.rent[1] >= item.rentPrice ){
                            return item
                        }
                    }
                }else{
                    return item
                }
            });
        },
        filterByContractDate: function () {
            return this.filterByRent.filter((item) => {
                // console.log(item)
                if( this.filterQuery.leaseTerm[0] && this.filterQuery.leaseTerm[1] ){
                    let rentDateStart = Date.parse(item.contractBeganDate).valueOf(),
                        rentDateEnd = Date.parse(item.contractEndTime).valueOf(),
                        filterRentDateStart = Date.parse(this.filterQuery.leaseTerm[0]).valueOf(),
                        filterRentDateEnd = Date.parse(this.filterQuery.leaseTerm[1]).valueOf()
                        
                    if( filterRentDateStart <= rentDateStart && rentDateEnd <= filterRentDateEnd ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByGroup: function () {
            return this.filterByContractDate.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.landlordName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByLeaseType: function () {
            return this.filterBySales.filter((item) => {
                if(this.filterQuery.type){
                    if(this.filterQuery.type === 'PAPER'){
                        if(item.isPaperContract){
                            return item
                        }
                    }else{
                        if(!item.isPaperContract){
                            return item
                        }
                    }
                }else{
                    return item
                }
            });
        },
        filterByStatus: function () {
            return this.filterByLeaseType.filter((item) => {
                if(this.filterQuery.status){
                    if(item.billStatus == this.filterQuery.status ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByNoPic: function () {
            return this.filterByStatus.filter((item) => {
                if(this.filterQuery.noPic){
                    // console.log('item', item)
                    if(item.useElectricityUtility){
                        if(!this.checkMeterUploaded(item, item.contractBeginTime, item.electricityUtilityDateList)){
                            return item
                        }
                    }
                    if(item.useGasUtility){
                        if(!this.checkMeterUploaded(item, item.contractBeginTime, item.gasUtilityDateList)){
                            return item
                        }
                    }
                    if(item.useWaterUtility){
                        if(!this.checkMeterUploaded(item, item.contractBeginTime, item.waterUtilityDateList)){
                            return item
                        }
                    }
                }else{
                    return item
                }
            });
        },
        filterByNoPicDate: function () {
            return this.filterByNoPic.filter((item) => {
                if(this.filterQuery.date.length){
                    if(item.useElectricityUtility){
                        if(!this.checkUploadDate(item, item.contractBeginTime, item.electricityUtilityDateList)){
                            return item
                        }
                    }
                    if(item.useGasUtility){
                        if(!this.checkUploadDate(item, item.contractBeginTime, item.gasUtilityDateList)){
                            return item
                        }
                    }
                    if(item.useWaterUtility){
                        if(!this.checkUploadDate(item, item.contractBeginTime, item.waterUtilityDateList)){
                            return item
                        }
                    }
                    
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByNoPicDate.filter((leaseItem) => {
                if( this.filterWord ){
                    if( leaseItem.tenantName.includes(this.filterWord) || leaseItem.address.includes(this.filterWord) || leaseItem.tenantPhone.includes(this.filterWord) ){
                        return leaseItem
                    }
                }else{
                    return leaseItem
                }
            });
        },
        // filterResult: function () {
        //     if( this.leaseDataEmpty == false && this.leaseDataError == false && this.isLoading == false ){
        //         if( this.filterByWord.length == 0 ){
        //             this.filterEmpty = true
        //             this.$store.dispatch('setFilterResultTotal', 0)
        //         }else{
        //             this.filterEmpty = false
        //             this.$store.dispatch('setFilterResultTotal', this.filterByWord.length)
        //             return this.filterByWord
        //         }
        //     }
            
        // },
        ...mapGetters({
            filterWord: 'GET_BIZ_LEASE_PROCESS_MGT_FILTER_WORD',
            filterQuery: 'GET_BIZ_LEASE_PROCESS_MGT_FILTER_QUERY',
            leaseProcessList: 'GET_BIZ_LEASE_PROCESS_MGT_LIST',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        AlartMsg,
        Modal,
        newBill,
        autoCreate,
        autoSend,
        contractRelease,
        tableLoading,
        checkIn,
        uploadMeterRecord,
        releaseAppeal,
        wordTipsHover,
        selectRecord
    }
}
</script>
<style lang="scss">
    .table-list.lease-done{
        margin-bottom: 290px;
        .table-list-title .contract-date,
        .table-list-body ul li .contract-date{
            position: relative;
            width: 155px;
            margin-right: 20px;
        }
        .table-list-title .address,
        .table-list-body ul li .address{
            width: 180px;
            margin-right: 20px;
        }
        .table-list-body ul li .address{
            line-height: 1.5;
        }
        .table-list-title .lease-type,
        .table-list-body ul li .lease-type{
            width: 56px;
            margin-right: 20px;
        }
        .table-list-title .lease-status,
        .table-list-body ul li .lease-status{
            position: relative;
            width: 56px;
            margin-right: 20px;
            .info{
                position: absolute;
                top: 0;
                right: -7px;
            }
        }
        .table-list-title .pay-status,
        .table-list-body ul li .pay-status{
            width: 178px;
            margin-right: 20px;
        }
        .table-list-body ul li .pay-status{
            >span{
                border-radius: 4px;
                font-weight: 500;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 9px 13px;
            }
            .red{
                background-color: rgba(252, 113, 113, 0.1);
                color: #fc7171;
            }
            .gray{
                background-color: #f3f3f3;
                color: #676362;
            }
            .blue{
                background-color: rgba(79, 181, 192, 0.1);
                color: #71aae5;
            }
        }
        .table-list-title .record,
        .table-list-body ul li .record{
            width: 118px;
            margin-right: 20px;
        }
        .table-list-title .tenant,
        .table-list-body ul li .tenant{
            width: 42px;
            margin-right: 20px;
            word-break: break-all;
        }
        .table-list-title .agent,
        .table-list-body ul li .agent{
            width: 42px;
            margin-right: 20px;
            word-break: break-all;
        }
        .table-list-title .rent,
        .table-list-body ul li .rent{
            width: 43px;
            text-align: right;
            margin-right: 20px;
        }
        
        #modal.throw-lease{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/leaseMgt/leaseProcess/LeaseProcessList.vue